module.exports = "<div class=\"player-card\">\n  <div *ngFor=\"let player of players | async\">\n    <div *ngIf=\"player.uid === user.uid\">\n      <ul>\n        <li>{{player.username}}</li>\n        <li>{{player.uid}}</li>\n      </ul>\n    </div>\n  </div>\n\n  <div *ngIf=\"!user\">\n    <button routerLink=\"/login\">login</button>\n  </div>\n\n\n\n  <div *ngIf=\"user\">\n    <button (click)=\"logout()\">logout</button>\n  </div>  \n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Space-Janitor/src/app/player/player.component.html
// module id = ../../../../../src/app/player/player.component.html
// module chunks = main